module.exports = __webpack_public_path__ + "static/media/piper_nudging paw_1_right.0dd27457.svg";